// test2712
(2712 && 0);
